import { MapPlusButton } from 'features/siteView'
import { isNil } from 'lodash'
import { MapPlusMenu } from 'pages/siteView/siteMap/popupMenus/editMode/plusMenu/MapPlusMenu'
import React, { FC, RefObject, useState } from 'react'
import { createPortal } from 'react-dom'
import styled from 'styled-components'

const AddSectionContainer = styled.div<{ $menuOpen: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: end;
  width: ${({ $menuOpen }) => ($menuOpen ? '220px' : '56px')};
  transition: width 200ms;
  overflow: hidden;
`

const FloatingContainer = styled.div`
  position: absolute;
  bottom: 2%;
  right: 2%;
  z-index: 100;
`

interface MapPlusMenuOverlayContainerProps {
  /**
   * If you want to display this menu in a different location (e.g. so it can be spaced correctly with other elements),
   * you can pass a ref for a div that this component will render into.
   * */
  divToPortalInto: RefObject<HTMLDivElement> | undefined
}
export const MapPlusMenuOverlayContainer: FC<
  MapPlusMenuOverlayContainerProps
> = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const children = (
    <AddSectionContainer $menuOpen={isMenuOpen}>
      <MapPlusMenu isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
      <MapPlusButton isSelected={isMenuOpen} setIsSelected={setIsMenuOpen} />
    </AddSectionContainer>
  )

  return isNil(props.divToPortalInto?.current) ? (
    <FloatingContainer>{children}</FloatingContainer>
  ) : (
    createPortal(children, props.divToPortalInto.current)
  )
}
